import React from 'react';

const Connect = () => (
  <svg width="50" height="10" viewBox="0 0 50 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="10" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="16" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="22" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="28" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="34" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="40" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="46" cy="1" r="1" fill="#C1C3C6" />
    <circle cx="4" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="10" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="16" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="22" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="28" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="34" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="40" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="46" cy="9" r="1" fill="#C1C3C6" />
    <circle cx="1" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="7" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="13" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="19" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="25" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="31" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="37" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="43" cy="5" r="1" fill="#C1C3C6" />
    <circle cx="49" cy="5" r="1" fill="#C1C3C6" />
  </svg>
);

export default Connect;
